import { all, call, fork, put, takeEvery, getContext } from 'redux-saga/effects';
import * as actions from './actions';
import { getApplyUniConfig } from '../../api/api';
import { logout } from '../auth/actions';
import { ApplyConfigActionTypes } from './types';

function* handleGetApplyConfig(action: ReturnType<typeof actions.getApplyConfigRecord>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleGetConfig');
      return;
    }

    const res = yield call(getApplyUniConfig, { idToken, uni: action.payload.uni });
    yield put(actions.getApplyConfigRecordSuccess(res.config));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getApplyConfigRecordFailure(err.message!));
    } else {
      yield put(actions.getApplyConfigRecordFailure('An unknown error occured.'));
    }
  }
}

function* watchGetApplyConfig() {
  yield takeEvery(ApplyConfigActionTypes.GET_APPLY_CONFIG, handleGetApplyConfig);
}

function* ApplyConfigSaga() {
  yield all([fork(watchGetApplyConfig)]);
}

export default ApplyConfigSaga;
